import React from "react";
import { connect } from "react-redux";
import { HistoryContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { MemberSwitchTypeWidget } from "widgets";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Cards, Displays, Headers, Icons, Navigations } from "components";

class HistoryContainer extends React.Component {
  state = {};

  _handleClick = (e) => {
    switch (e) {
      case "1":
        this.props.router.navigate(ROUTE_PATH.HISTORY_PRODUCT_WARRANTY);
        break;
      case "2":
        this.props.router.navigate(ROUTE_PATH.HISTORY_ACTIVITY);
        break;
      default:
        break;
    }
  };

  render() {
    const { i18n, t } = this.props;
    const { isLoading, /* isActive */ typeSelected } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("History", { ns: "common" }),
        path: ROUTE_PATH.HISTORY,
      },
    ];
    return (
      <HistoryContainerStyled selected={typeSelected}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="history_container">
          <Headers.PageHeader
            theme_center
            title={"HISTORY"}
            subTitle={"ประวัติ"}
          />
          <MemberSwitchTypeWidget type="4" />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div
                className="menu_item_wrap"
                onClick={() => this._handleClick("1")}
              >
                <Cards.MenuItem
                  icon={<Icons.MemberPerson2 color="#FFFFFF" />}
                  name={
                    i18n.language === "en"
                      ? "Product Registration History"
                      : "ประวัติการลงทะเบียนสินค้า"
                  }
                />
              </div>
              <div
                className="menu_item_wrap"
                onClick={() => this._handleClick("2")}
              >
                <Cards.MenuItem
                  icon={<Icons.MemberCoperate color="#FFFFFF" />}
                  name={
                    i18n.language === "en"
                      ? "Activity Registration History"
                      : "ประวัติการลงทะเบียนกิจกรรม"
                  }
                />
              </div>
            </>
          )}
        </div>
      </HistoryContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common", "history"])(withRouter(HistoryContainer)));
